<template>
    <div class="vld-parent">
        <Loading 
        :active.sync="isLoading"
        :is-full-page="false"
        :loader="'dots'"
        ></Loading>
        <div class="row g-3">
            <template v-for="post in posts">
                <PostItem :post="post" :key="post.id"></PostItem>
            </template>
            <div v-if="!posts.length && !isLoading">
                <p class="h2 py-5">No hay ítems para mostrar.</p>
            </div>
        </div>
        <div class="row">
            <div class="col text-center">
                <button
                    type="button"
                    class="btn btn-seleccionar-todo mb-5 mt-3"
                    v-if="showLoadMore && !isLoading"
                    @click="$emit('load-more')"
                >
                    Cargar más noticias
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.vld-parent {
    min-height: 10em;
}
</style>

<script>
import PostItem from "./PostItem.vue";
export default {
    components: { PostItem },
    props: {
        posts: Array,
        isLoading: Boolean,
        showLoadMore: Boolean,
    },
    mounted() {

    },
    emits: ["load-more"],
};
</script>
